import { apiFetch } from '../../../lib/apiClient';

export interface TranscriptEntryDto {
  userId: string;
  userName: string;
  text: string;
  startTime: number;
  timestamp: number;
  source?: 'rtms' | 'zoom_webhook';
  messageType?: 'transcript' | 'system_event';
  eventType?: string;
  participantRole?: 'host' | 'internal' | 'guest';
  externalIdentityId?: number;
}

export interface TranscriptPageResult {
  entries: TranscriptEntryDto[];
  totalEntries: number;
  sentEntries: number;
}

export async function fetchTranscriptPage(
  sessionUuid: string,
  before: number
): Promise<TranscriptPageResult> {
  const params = new URLSearchParams({ before: String(before) });
  return apiFetch<TranscriptPageResult>(
    `/api/meetings/sessions/${encodeURIComponent(sessionUuid)}/transcript?${params.toString()}`
  );
}
